<template>
  <ppt-slide-viewer module-code="sjq_jm2" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "SjqJm2",
  components: { PptSlideViewer }
};
</script>
